/*
* ぽちボタンクリック後の処理
*/ 

class afrPostJobDetails {
  constructor(that) {
    this.that = that
    this.formName = "求人情報詳細"
    this.that.$('.search_form_wrap').show()
  }

  returnFormName() {
    return this.formName
  }

  getInputData() {
    const $ = this.that.$
    const moment = this.that.moment
    moment.locale("ja")
    const store = this.that.store
    const func = this.that.func

    store.commit('setValue', ['jobDetails', 'input_expectedJobPostCount', func.textEscape($("#expectedJobPostCount").val()), 'expectedJobPostCount'])
    store.commit('setValue', ['jobDetails', 'input_jobType', func.textEscape($("#jobType").val()), 'jobType'])
    store.commit('setValue', ['jobDetails', 'input_employmentType', func.textEscape($("#employmentType").val()), 'employmentType'])
    store.commit('setValue', ['jobDetails', 'input_workLocation', func.textEscape($("#workLocation").val()), 'workLocation'])
    store.commit('setValue', ['jobDetails', 'input_customerJobSiteUrl', func.textEscape($("#customerJobSiteUrl").val()), 'customerJobSiteUrl'])
  }

  setVal (balanceInfoMsg) {
    const store = this.that.store

    const sendVal = 
`
◎求人情報詳細
必要想定求人票数：${store.state.formData.jobDetails.input_expectedJobPostCount}
職種：${store.state.formData.jobDetails.input_jobType}
雇用形態：${store.state.formData.jobDetails.input_employmentType}
勤務地：${store.state.formData.jobDetails.input_workLocation}
お客様の求人サイトURL：${store.state.formData.jobDetails.input_customerJobSiteUrl}
`
    store.commit('setTalknoteMessage', ['jobDetails', sendVal])
  } 
}

export default {
  afrPostJobDetails
}